import $ from "jquery";

export const SetupProfile = function () {
	if (!($("#setup-profile").length > 0)) return false;

	const $elms = {
		page: $("#setup-profile"),
		form: $("#setup-profile-form"),
		uploadPhoto: $(".js-upload-photo"),
		removePhoto: $(".js-remove-photo"),
		saveProfile: $(".js-save-profile"),
		photo: $("#setup-profile-photo"),
		photoInput: $(
			'<input type="file" accept="image/jpeg,image/png,image/gif,image/webp" style="display: none;">',
		),
		firstName: $("#fname"),
		lastName: $("#lname"),
		defaultNote: $("#default-note"),
		generatedNote: $("#generated-note"),
		generatedUsername: $("#generated-username"),
	};

	const sanitizeInput = (input) => {
		// Remove any non-alphanumeric characters except spaces
		return input.replace(/[^a-zA-Z0-9\s]/g, "");
	};

	const sanitizeUsername = (input) => {
		// Remove all non-alphanumeric characters including spaces
		return input.replace(/[^a-zA-Z0-9]/g, "");
	};

	const generateUsername = () => {
		const firstName = $elms.firstName.val().toLowerCase().trim();
		const lastName = $elms.lastName.val().toLowerCase().trim();

		if (firstName && lastName) {
			// Remove spaces for username generation
			const cleanFirstName = sanitizeUsername(firstName);
			const cleanLastName = sanitizeUsername(lastName);
			const username = `${cleanFirstName}${cleanLastName}`;
			$elms.generatedUsername.text(username);
			// $elms.defaultNote.hide();
			// $elms.generatedNote.show();
		} else {
			$elms.generatedUsername.text("");
			// $elms.defaultNote.show();
			// $elms.generatedNote.hide();
		}
	};

	const validateForm = () => {
		const isValid =
			$elms.firstName.val() && $elms.lastName.val(); /* && selectedPhotoFile */
		$elms.saveProfile.prop("disabled", !isValid);
		return isValid;
	};

	// Initial validation and username generation
	validateForm();
	generateUsername();

	// Add input event listeners for real-time validation and username generation
	$elms.firstName.on("input", function () {
		const sanitized = sanitizeInput($(this).val());
		$(this).val(sanitized);
		validateForm();
		generateUsername();
	});

	$elms.lastName.on("input", function () {
		const sanitized = sanitizeInput($(this).val());
		$(this).val(sanitized);
		validateForm();
		generateUsername();
	});

	$elms.uploadPhoto.on("click", function () {
		$elms.photoInput.trigger("click");
	});

	$elms.form.on("submit", function (e) {
		e.preventDefault();

		const firstName = $elms.firstName.val();
		const lastName = $elms.lastName.val();
		const username = $elms.generatedUsername.text();

		if (!firstName || !lastName) {
			alert("All fields are required");
			return;
		}

		// Create FormData object for file upload
		const formData = new FormData();
		formData.append("action", "setup_profile");
		formData.append("first_name", firstName);
		formData.append("last_name", lastName);
		formData.append("username", username);
		formData.append("nonce", window.CFG.nonce);
		formData.append("traject_id", $elms.page.attr("data-traject-id"));
		formData.append("team_index", $elms.page.attr("data-team-index"));

		// Disable form during submission
		$elms.saveProfile.prop("disabled", true);
		$elms.saveProfile.addClass("is-loading");

		$.ajax({
			url: window.CFG.ajaxUrl,
			type: "POST",
			data: formData,
			processData: false, // Don't process the data
			contentType: false, // Don't set content type
			success: function (response) {
				if (response.success) {
					// Handle success - maybe redirect or show success message
					if (response.data.user_id) {
						window.location.href = `${window.CFG.siteURL}/setup-profile-photo/${response.data.user_id}`;
					}
				} else {
					// Handle error from server
					alert(
						response.data?.message ||
							"Failed to setup profile. Please try again.",
					);
				}
			},
			error: function (xhr, status, error) {
				console.error(error);
				alert("Failed to setup profile. Please try again.");
			},
			complete: function () {
				// Re-enable form after submission
				$elms.saveProfile.prop("disabled", false);
				$elms.saveProfile.removeClass("is-loading");
			},
		});
	});
};
